import { RecursivePartial, ILocaleValues } from "../interfaces/values";

import de from "./de";
import enAU from "./en-AU";
import enGB from "./en-GB";
import enUS from "./en-US";
import es from "./es";
import fr from "./fr";
import pt from "./pt";
import it from "./it";
import ru from "./ru";
import he from "./he";
import ge from "./ge";
import nl from "./nl";

// This file exists for the demo app. Don't use this in real life.
export default {
    de,
    enAU,
    enGB,
    enUS,
    es,
    it,
    fr,
    pt,
    ru,
    he,
    ge,
    nl
};
